import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

export const DataUpdateInfo = () => {
  return (
    <Tooltip
      arrow
      title={
        <React.Fragment>
          <Typography variant="h5" color="inherit">
            Data Update Frequency
          </Typography>
          <br />
          <Typography color="inherit">
            Property information is updated daily. Some fields such as estimated
            true cash value are updated yearly.
          </Typography>
          <br />
          <Typography color="inherit">
            Tax status and occupancy are updated weekly.
          </Typography>
          <br />
          <Typography color="inherit">
            <em>Actual update times may vary.</em>
          </Typography>
        </React.Fragment>
      }
    >
      <Typography
        color="inherit"
        style={{ textAlign: 'center' }}
        variant="caption"
      >
        Data Updated Daily - Learn More
      </Typography>
    </Tooltip>
  );
};
